
const digest = '4fde64fa87d12696b73caac4092aee4333aeaa96f6a70f341ff3d785482c0c0e';
const classes = {"wrapper":"_wrapper_17wc5_1","iconWrapper":"_iconWrapper_17wc5_15","title":"_title_17wc5_22","text":"_text_17wc5_25"};
const css = `._wrapper_17wc5_1 {
  background: #ffffff;
  border-radius: 25px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ffffff;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}
._wrapper_17wc5_1 ._iconWrapper_17wc5_15 {
  border-radius: 100%;
  height: 50px;
  width: 50px;
  padding: 10px;
  background: #d9e2ff;
}
._wrapper_17wc5_1 ._title_17wc5_22 {
  font-weight: 600;
}
._wrapper_17wc5_1 ._text_17wc5_25 {
  font-size: 12px;
}
._wrapper_17wc5_1:hover {
  border: 1px solid rgba(0, 84, 188, 0.2);
  background-color: #f3f5ff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  